module.exports = __webpack_public_path__ + "career-icon-vision.xDAe9NNX.svg";